import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import Button from '../UI/Button';

const Navbar = () => {
  const { isAuthenticated, user, logout, isAdmin, isSuperAdmin } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [showUserMenu, setShowUserMenu] = useState(false);

  const handleLogout = () => { logout(); navigate('/'); setShowUserMenu(false); };

  const swaggerUrl = process.env.REACT_APP_OPEN_API_DOC_URL || 'http://localhost:8000/docs';
  const adminPanelUrl = process.env.REACT_APP_ADMIN_PANEL_URL || '/admin';
  const supersetUrl = process.env.REACT_APP_SUPERSET_APACHE_URL || 'https://superset.example.com';

  const isActive = (path) => location.pathname === path;

  return (
    <nav className="bg-white border-b border-brand-border sticky top-0 z-50">
      <div className="container-custom">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <Link to="/" className="font-semibold text-brand-dark text-xl tracking-tight">
            Voting Data API
          </Link>

          {/* Desktop nav links – same as before, with brand colors */}
          <div className="hidden md:flex items-center space-x-8">
            <Link to="/docs" className={`text-sm font-medium transition-colors ${isActive('/docs') ? 'text-brand-red font-bold' : 'text-brand-dark hover:text-brand-red'}`}>
              Документація
            </Link>
            <Link to="/#features" className="text-sm font-medium text-brand-dark hover:text-brand-red">Можливості</Link>
            {/*<Link to="/#api" className="text-sm font-medium text-brand-dark hover:text-brand-red">API</Link>*/}
            <a href={swaggerUrl} target="_blank" rel="noopener noreferrer" className="text-sm font-medium text-brand-dark hover:text-brand-red">Swagger UI</a>
            {isAuthenticated && isSuperAdmin && (
              <a href={adminPanelUrl} target="_blank" className="text-sm font-medium text-brand-red hover:text-brand-red/80">Адмін панель</a>
            )}
            {isAuthenticated && (
              <a href={supersetUrl} target="_blank" className="text-sm font-medium text-green-600 hover:text-green-700">Аналітика</a>
            )}
            {isAuthenticated && isAdmin && (
              <Link to="/admin/users" className="text-sm font-medium text-brand-red hover:text-brand-red/80">Користувачі</Link>
            )}
          </div>

          {/* Auth / User Menu */}
          <div className="relative">
            {isAuthenticated ? (
              <>
                <button onClick={() => setShowUserMenu(!showUserMenu)} className="flex items-center space-x-2 px-3 py-2 rounded-md hover:bg-gray-50">
                  <div className="w-8 h-8 bg-gray-100 rounded-full flex items-center justify-center">
                    <span className="text-gray-600 font-medium text-sm">{user?.name?.charAt(0) || user?.username?.charAt(0) || 'U'}</span>
                  </div>
                  <span className="text-sm text-gray-700 hidden sm:inline">{user?.name || user?.username || user?.email}</span>
                  <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" /></svg>
                </button>
                {showUserMenu && (
                  <div className="absolute right-0 mt-2 w-48 bg-white rounded-md shadow-lg border border-gray-200 py-1 z-50">
                    <Link to="/profile" className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-50">Profile</Link>
                    {isSuperAdmin && <a href={adminPanelUrl} target="_blank" className="block px-4 py-2 text-sm text-brand-red hover:bg-gray-50">Адмін панель</a>}
                    <a href={supersetUrl} target="_blank" className="block px-4 py-2 text-sm text-green-600 hover:bg-gray-50">Аналітика</a>
                    {isAdmin && <Link to="/admin/users" className="block px-4 py-2 text-sm text-brand-red hover:bg-gray-50">Користувачі</Link>}
                    <button onClick={handleLogout} className="block w-full text-left px-4 py-2 text-sm text-red-600 hover:bg-gray-50">Вийти</button>
                  </div>
                )}
              </>
            ) : (
              <div className="flex items-center space-x-3">
                <Link to="/login"><Button variant="ghost" size="sm">Увійти</Button></Link>
                <Link to="/register"><Button size="sm">Реєстрація</Button></Link>
              </div>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;